import { render, staticRenderFns } from "./MyMentees.vue?vue&type=template&id=2207c2fe&"
import script from "./MyMentees.vue?vue&type=script&lang=js&"
export * from "./MyMentees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports